module.exports = __webpack_public_path__ + "img/intro2.1247dc10.png";